// extracted by mini-css-extract-plugin
module.exports = {"text":"relatedlink-module--text--1za-k","item":"relatedlink-module--item--3lCdf","date":"relatedlink-module--date--2ZiSk"};